// src/components/games/crossroads/DiceRollIndicator.tsx
// Floating dice roll result indicator

import React, { useEffect, useState } from 'react';
import { IonBadge } from '@ionic/react';
import './DiceRollIndicator.css';

interface DiceRollIndicatorProps {
  value: number;
  isReroll?: boolean;
  onComplete?: () => void;
}

const DiceRollIndicator: React.FC<DiceRollIndicatorProps> = ({
  value,
  isReroll = false,
  onComplete,
}) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      if (onComplete) {
        setTimeout(onComplete, 300); // Wait for fade out animation
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  if (!visible) return null;

  return (
    <div className={`dice-roll-indicator ${isReroll ? 'reroll' : ''}`}>
      <IonBadge color="primary" className="dice-badge">
        🎲 {value}
      </IonBadge>
      {isReroll && <span className="reroll-label">Rerolled!</span>}
    </div>
  );
};

export default DiceRollIndicator;
